import { createContext, useState, type ReactNode } from 'react';

import { DEFAULT_FEATURE_FLAGS, type FeatureFlagValues } from '@/utils/featureFlags';

export const FeatureFlagsContext = createContext<FeatureFlagValues>(DEFAULT_FEATURE_FLAGS);

type FeatureFlagsProviderProps = {
  /** Undefined on pages without server flag props, such as a static 404. */
  flags: FeatureFlagValues | undefined;
  children: ReactNode;
};

export function FeatureFlagsProvider({ flags, children }: FeatureFlagsProviderProps) {
  // Keep the last resolved values when navigating through a page without flag props.
  const [lastKnown, setLastKnown] = useState(flags ?? DEFAULT_FEATURE_FLAGS);
  if (flags !== undefined && flags !== lastKnown) setLastKnown(flags);

  return (
    <FeatureFlagsContext.Provider value={flags ?? lastKnown}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}
